import {
	DecisionKind,
	AttributeType,
	ChoiceValueDecisionState,
} from '@viamedici-spc/configurator-ts';
import throttle from 'throttleit';

import {
	setBuriedBaseSize,
	setHousingSize, setMaxHeight, setNumberOfHeads, setIomoData,
	setIomoHeadHousingSize,
	setIomoHeadLightDistribution,
	setIomoHeadsData,
	setPoleHeight, setSecondDoor,
	setSelectedHead, setSeparateBuriedBase, setTestMaterial2, setTestMaterial1, setPoleShape, setPoleDiameter, setPoleData
} from './iomoSlice';
import {getValueOfFeature, spcExpliciteChoiceDecision} from '../util/values';
import {setProductModel, storeConfiguration} from '../slices/configurationSlice';
import {
	selectIomoBracket, selectIomoColorThemeMaterialBody, selectIomoColorThemeMaterialRing,
	selectIomoDesign,
	selectIomoDesignData,
	selectIomoHousingColourInlay,
	selectIomoHousingSize,
	selectIomoHousingSizeInclCustom,
	selectIomoLayout,
	selectIomoMaxHeight,
	selectIomoNumberOfHeadsValue,
	selectIomoOffsetFromTop
} from './iomoSelectors';
import {selectSpcSession} from '../selectors';
import {stringToAttributeId} from '../components/spc/util/spcUtils';
import {iomoDesignOptions} from './iomoModel';
import {getFilteredDecisions} from '../util/getFilteredDecisions';


const throttledStore = throttle((s) => {
	s.dispatch(storeConfiguration());
}, 1500);

export const iomoMiddleware = store => next => async action => {
	const s = store.getState();

	// before triggering action
	if (action.type === 'iomo/setPoleHeight') {
		const state = store.getState();
		// preliminary rule enforcement
		let poleDiameter = state.iomo.data.general.poleDiameter;
		let poleShape = state.iomo.data.general.poleShape;
		if (action.payload.id <= 8 && state.iomo.data.general.poleShape === 'conical' && state.iomo.data.general.poleDiameter !== 76) {
			// height Diameter 89 only with canonical anf height <= 8
			poleShape = 'conical';
			poleDiameter = '76';
		}
		// preliminary rule enforcement
		if (action.payload.id === 10 && state.iomo.data.general.poleShape === 'cylindrical') {
			// height 10 only with canonical
			poleShape = 'conical';
			poleDiameter = '76';
		}
		store.dispatch(setPoleData({poleShape: poleShape, poleHeight: action.payload.id, poleDiameter: poleDiameter}));
	}

	if (action.type === 'iomo/setPoleShape') {
		const state = store.getState();
		// preliminary rule enforcement
		let poleDiameter = state.iomo.data.general.poleDiameter;
		let poleHeight = state.iomo.data.general.poleHeight;
		if (action.payload.id === 'conical' && (state.iomo.data.general.poleDiameter !== 76 || state.iomo.data.general.poleDiameter !== 89)) {
			poleDiameter = '76';
		}
		if (action.payload.id === 'cylindrical' && (state.iomo.data.general.poleDiameter !== 114 || state.iomo.data.general.poleDiameter !== 140 || state.iomo.data.general.poleDiameter !== 159)) {
			poleDiameter = '114';
		}
		if (action.payload.id === 'cylindrical' && (state.iomo.data.general.poleHeight > 9)) {
			poleHeight = '9';
		}
		store.dispatch(setPoleData({poleShape: action.payload.id, poleHeight: poleHeight, poleDiameter: poleDiameter}));

	}

	if (action.type === 'iomo/setPoleDiamater') {
		const state = store.getState();
		// preliminary rule enforcement
		let poleShape = state.iomo.data.general.poleShape;
		let poleHeight = state.iomo.data.general.poleHeight;
		if ((action.payload.id === 114 || action.payload.id === 140 || action.payload.id === 159) && state.iomo.data.general.poleShape !== 'cylindrical') {
			poleShape = 'cylindrical';
			if (poleHeight === 10) poleHeight = '9';
		}
		if ((action.payload.id === 76 || action.payload.id === 89) && state.iomo.data.general.poleShape !== 'conical') {
			poleShape = 'conical';
		}
		store.dispatch(setPoleData({poleShape: poleShape, poleHeight: poleHeight, poleDiameter: action.payload.id}));
	}


	const result = next(action);

	// after the triggering action

	// ignore, if not Iomo
	if (s.status.family !== 'Iomo') return result;

	if (action.type === 'spc/startSpcSession/fulfilled') {
		const spcSession = selectSpcSession(store.getState());
		const iomoDefaults = [
			spcExpliciteChoiceDecision('root::Heads::Head::Housing::HS_HeadType', '195C'),
			spcExpliciteChoiceDecision('root::Poles::Pole::Basic::HS_Height', '7000'),
			spcExpliciteChoiceDecision('root::Heads::Cardinality::Count', '8'),
			spcExpliciteChoiceDecision('root::Poles::Cardinality::Count', '1'),
			spcExpliciteChoiceDecision('shared::ProductType::HS_PoleType', 'Standard'),
		];
		console.log('iomoDefaults', iomoDefaults);
		await spcSession.makeManyDecisions(iomoDefaults, {
			type: 'KeepExistingDecisions',
			conflictHandling: {type: 'Automatic'}, //{type: 'Manual', includeConstraintsInConflictExplanation: true}
		}).then(
			() => console.log('sessionMiddleware initial decisions made'),
			error => console.error('sessionMiddleware initial decisions failed', error)
		);
	}

	// when default session is updated...
	/*
	if (action.type === 'spc/updateConfiguration') {
		console.log('iomoMiddleWare spc updateConfiguration');
		// ...transfer changes of default head to single heads
		const changes = action.payload.changes.attributes.changed;
		const spcConfiguration = store.getState().spc.spcs.default?.configuration;

		//const housingSizeChanged = changes.some(c => c.key === 'root::HS_HousingSize');
		const colourTemperatureChanged = changes.some(c => c.key === 'root::LE_ColourTemperature_1');
		const lightDistributionChanged = changes.some(c => c.key === 'root::LE_LightDistribution_1');

		const heads = Array.from({ length: 8 }, (_, i) => ({
			//...housingSizeChanged && { housingSize: getValueOfFeature('root::HS_HousingSize', spcConfiguration) },
			...colourTemperatureChanged && { colourTemperature: getValueOfFeature('root::LE_ColourTemperature_1', spcConfiguration) },
			...lightDistributionChanged && { lightDistribution: getValueOfFeature('root::LE_LightDistribution_1', spcConfiguration) }
		}));
		store.dispatch(setIomoHeadsData({heads: heads}));
	}
	 */
	// enforce default state on start, when configuration is stored without the manual defaults
	if (action.type === 'configuration/store/fulfilled') {
		/*
		const spcSession = selectSpcSession(s);
		if (selectIomoHousingSize(s) === null) {
			// set matching default values for Iomo
			const headAttributes = [
				{id: 'root::HS_HousingSize', value: 'IomoGrande'},
				{id: 'root::LE_ColourTemperature_1', value: '3000K'},
				{id: 'root::LE_LightDistribution_1', value: 'Asymmetric'},
				{id: 'root::LE_DimmingLevel_1', value: 'Max'},
				{id: 'root::EB_ConstantLumenTechnology_1', value: 'None'},
				{id: 'root::EB_Zhaga_1', value: 'None'},
				{id: 'root::EB_ElectricalProtectionClass_1', value: 'Class2'},
				{id: 'root::EB_Control_1', value: 'NoDim'},
				{id: 'root::LE_Accessories_1', value: 'None'}
			];
			const spcAttributes = headAttributes.map((attribute) => spcExpliciteChoiceDecision(attribute.id, attribute.value)) ?? [];
			await spcSession.makeManyDecisions(spcAttributes, {type: 'KeepExistingDecisions'});
			// syncSpcToIomo();
		}
		 */
	}
	if (action.type === 'status/setSection') {
		if (action.payload.currentSection === 'iomoHeadDetail') {
			// always start with all-head settings when switching to heads section
			store.dispatch(setSelectedHead({selectedHead: null}));
		}
	}
	if (action.type === 'iomo/setHousingSize') {
		// transfer housing size to heads
		const heads = Array.from({length: 8}, (_, i) => ({
			...{housingSize: action.payload.id}
		}));
		store.dispatch(setIomoHeadsData({heads: heads}));

		// set housing size in SPC
		/*
		const spcSession = selectSpcSession(s);
		spcSession.makeDecision({
			type: AttributeType.Choice, attributeId: stringToAttributeId('root::HS_HousingSize'),
			choiceValueId: action.payload.id, state: ChoiceValueDecisionState.Included
		});
		 */
	}

	if (action.type === 'iomo/setPoleHeight') {
		// set HousingSize for Bollard to Piccolo or Medio depending on height
		store.dispatch(setMaxHeight({value: +action.payload.id - selectIomoOffsetFromTop(s)}));
	}
	if (action.type === 'iomo/setBracket') {
		const newDesign = action.payload.id;
		// ensure maximal head number on cluster layout
		if (selectIomoLayout(s) === 'cluster') {
			if ((newDesign === '250' || newDesign === '195') && selectIomoNumberOfHeadsValue(s) > 5) {
				setNumberOfHeads({value: 5});
			} else if (newDesign === '160' && selectIomoNumberOfHeadsValue(s) > 4) {
				setNumberOfHeads({value: 4});
			}
		}
	}
	if (action.type === 'iomo/setBase') {
		const newBase = action.payload.id;
		if (newBase !== 'FlangePlateDE') {
			store.dispatch(setSeparateBuriedBase({id: 'none'}));
			store.dispatch(setBuriedBaseSize({id: '1200'}));
		}
		if (newBase !== 'buriedbase') {
			store.dispatch(setSeparateBuriedBase({id: 'none'}));
			store.dispatch(setBuriedBaseSize({id: null}));
		}
	}
	if (action.type === 'iomo/setIomoDesign') {
		const newDesign = action.payload.id;
		const newModel = iomoDesignOptions.find(d => d.id === newDesign).model;
		console.log('iomo/setIomoDesign', newDesign, newModel, s.iomo.data.design, selectIomoDesign(s));
		// switch model if necessary
		if (newDesign !== selectIomoDesign(s)) {
			//await store.dispatch(setProductModel({ productModel: newModel}));
		}

	}

	// additional actions for iomo that require config storage
	if (action.type === 'iomo/setIomoDesign' ||
		action.type === 'iomo/setPoleHeight' ||
		action.type === 'iomo/setNumberOfHeads' ||
		action.type === 'iomo/setLayout' ||
		action.type === 'iomo/setSeparateBuriedBase' ||
		action.type === 'iomo/setSecondDoor' ||
		action.type === 'iomo/setFuseBox' ||
		action.type === 'iomo/setPoleDiameter' ||
		action.type === 'iomo/setPoleMaterial' ||

		action.type === 'iomo/setMaxHeight' ||
		action.type === 'iomo/setMinHeight' ||
		action.type === 'iomo/setMaxAngle' ||
		action.type === 'iomo/setMinAngle' ||
		action.type === 'iomo/setSelectedHeadHeight' ||
		action.type === 'iomo/setSelectedHeadAngle' ||

		action.type === 'iomo/setIomoHousingSize' ||
		action.type === 'iomo/setIomoHeadsData' ||

		action.type === 'iomo/setIomoColorTheme' ||
		action.type === 'iomo/setIomoOpticalSystem' ||


		action.type === 'iomo/setIomoHeadHeight' ||
		action.type === 'iomo/setIomoHeadAngle' ||
		action.type === 'iomo/setIomoHeadType' ||
		action.type === 'iomo/setIomoHeadColourTemperature' ||
		action.type === 'iomo/setIomoHeadLightDistribution' ||
		action.type === 'iomo/setIomoHeadCap' ||
		action.type === 'iomo/setIomoHeadHousingSize' ||
		action.type === 'iomo/setIomoHeadColourTemperature' ||
		action.type === 'iomo/setBase'

	) {
		throttledStore(store);
	}

	if (action.type === 'shortNumber/loadConfigByShortNumberLoading/fulfilled') {
		const loadedConfig = s.shortNumber.data.loadedConfig.configurationData;
		await store.dispatch(setIomoData(
			{
				design: loadedConfig.design,
				heads: loadedConfig.heads,
				general: loadedConfig.general,
				selectedHead: null,
				projectName: '',
				headTableVisible: false,
			}
		));
	}
	if (action.type === 'iomo/setIomoColorTheme') {
		const state = store.getState();
		const materialBody = selectIomoColorThemeMaterialBody(state);
		const materialRing = selectIomoColorThemeMaterialRing(state);
		store.dispatch(
			setTestMaterial1({material: materialBody})
		);
		store.dispatch(
			setTestMaterial2({material: materialRing})
		);
	}
	return result;
};
